// export const API_URL = 'https://getreminded-back-stage.appelloproject.xyz'; // STAGE
export const API_URL = 'https://v3-prod.backend.getreminded.com.au'; // PROD
